import { observer } from 'mobx-react-lite'
import React, { Fragment } from 'react'
import DatePicker from '../../../../../FormComponents/DatePicker'
import Switch from '../../../../../FormComponents/Switch'

export default observer(function TimeframeSection({ values, handleBlur, setFieldValue, missingContentDates }) {

  return (
    <Fragment>
      <div className="flex justify-between items-center mt-8 mb-4">
        <p className="font-bold dark:text-white">Timeframe</p>
        <Switch name="timeframe_visible" value={values.timeframe_visible} onChange={({ target: { checked }}) => setFieldValue('timeframe_visible', checked, true)} eyeSwitch />
      </div>
      {missingContentDates && (
        <p className="mb-4 rounded-lg bg-amber-50 dark:bg-rb-dark-mode-lighter px-3 py-2 text-sm text-amber-700 dark:text-amber-400">
          No content dates are set yet, so the timeframe can't be filled in automatically. Add start and end dates to the content pieces in the Project Timeline, or pick the dates below manually.
        </p>
      )}
      <div className="flex gap-2 w-full mb-4">
        <DatePicker
          label='Start date'
          name='start_date'
          onBlur={handleBlur}
          selected={values.start_date}
          onChange={(date) => setFieldValue('start_date', date)}
        />
        <DatePicker
          label='End date'
          name='end_date'
          onBlur={handleBlur}
          selected={values.end_date}
          onChange={(date) => setFieldValue('end_date', date)}
        />
      </div>
      <div className="border-1 w-full border-gray-100 dark:border-rb-dark-mode-lighter" />
    </Fragment>
  )
})